import React from "react";
import getConfig from "next/config";

import serializeSchema from "@lib/structuredData";

const {
  publicRuntimeConfig: {
    settings: { baseUrl, websiteStatics },
  },
} = getConfig();

const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    url: baseUrl,
    logo: `${websiteStatics}/images/logo.png`,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: serializeSchema(schema) }}
    />
  );
};

export default OrganizationSchema;
